// assistantScopeName(root) — the name the assistant's empty state addresses:
// "Ask anything about <this>" (2026-09-10 per Nika "instead of 'ask anything
// about symbols' say 'ask anything about {workspace}'"). ONE resolver, shared
// by the drawer hint (shared Chat.js) and the workspace starter builder
// (workspace/functions/assistantStarters.js), so both name the same thing.
//
// The workspace's own display name wins. An org's DEFAULT workspace is the
// exception: it is literally named "Default" (slug `default` — every org
// starts with one, e.g. /w/gita/default, live 2026-09-10), and "Ask anything
// about Default" names nothing a reader recognises. There, the ORGANISATION's
// name is the identity the member knows the space by — it is what the header
// switcher prints — so the hint uses it. '' when neither resolves (standalone
// simone, pre-boot), and the caller falls back to the generic Symbols line.
//
// Self-contained on purpose: it is held as a scope VALUE by the shared Chat
// component, which is frank.toJSON'd for platform delivery — a helper that
// called a sibling export by its bare name would read as undefined there
// (the FA204 trap Chat.js is organised around). The name precedence is the
// same one `workspaceDisplayName` (./activeWorkspaceRecord.js) states:
// `displayName` FIRST, the frozen legacy `name` second.

// The names an org's starter workspace ships with — inlined in BOTH functions
// below (not a shared module constant): each is registered on
// `context.functions` and frank-lifted on its own, where a module-scope
// binding or a sibling call reads as undefined (FA203/FA204).
export const isGenericWorkspaceName = (name) => {
  const n = String(name == null ? '' : name)
    .trim()
    .toLowerCase()
  return !n || ['default', 'workspace', 'main', 'untitled'].indexOf(n) !== -1
}

export const assistantScopeName = (root) => {
  if (!root || typeof root !== 'object') return ''
  const ws = root.workspace
  const wsName = String((ws && (ws.displayName || ws.name)) || '').trim()
  const generic = ['default', 'workspace', 'main', 'untitled'].indexOf(wsName.toLowerCase()) !== -1
  if (wsName && !generic) return wsName
  const org = root.org
  const orgName = String((org && (org.name || org.displayName)) || '').trim()
  return orgName
}
